<template>
    <div class="schedule-wrapper">
        <div class="schedule-day-select">
            <div class="schedule-day-select-input">
                <div class="width-100 relative"><div class="caption-text">Starting date</div></div>
                <Input type="text" textalign="center" value="07-04-2019" placeholder="dd-mm-yyyy" width="inline"></Input>
            </div>
        </div>
        <div class="schedule">
            <div class="schedule-timeline">
                <ul>
                </ul>
            </div>
            <div class="schedule-events">
                <ul>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Maandag</div>
                                <div class="schedule-top-day-number">7</div>
                            </div>
                        </div>
                        <ul>
                            <ScheduleCard />
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Dinsdag</div>
                                <div class="schedule-top-day-number">8</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Woensdag</div>
                                <div class="schedule-top-day-number">9</div>
                            </div>
                        </div>
                        <ul>

                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Donderdag</div>
                                <div class="schedule-top-day-number">10</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Vrijdag</div>
                                <div class="schedule-top-day-number">11</div>
                            </div>
                        </div>
                        <ul>
                            <ScheduleCard />
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Zaterdag</div>
                                <div class="schedule-top-day-number">12</div>
                            </div>
                        </div>
                        <ul>

                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Zondag</div>
                                <div class="schedule-top-day-number">13</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="schedule">
            <div class="schedule-events">
                <ul>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Maandag</div>
                                <div class="schedule-top-day-number">14</div>
                            </div>
                        </div>
                        <ul>
                            <ScheduleCard variant="without-card" />
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Dinsdag</div>
                                <div class="schedule-top-day-number">15</div>
                            </div>
                        </div>
                        <ul>

                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Woensdag</div>
                                <div class="schedule-top-day-number">16</div>
                            </div>
                        </div>
                        <ul>

                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Donderdag</div>
                                <div class="schedule-top-day-number">17</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Vrijdag</div>
                                <div class="schedule-top-day-number">18</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Zaterdag</div>
                                <div class="schedule-top-day-number">19</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Zondag</div>
                                <div class="schedule-top-day-number">20</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="schedule">
            <div class="schedule-events">
                <ul>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Maandag</div>
                                <div class="schedule-top-day-number">21</div>
                            </div>
                        </div>
                        <ul>
                            <ScheduleCard></ScheduleCard>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Dinsdag</div>
                                <div class="schedule-top-day-number">22</div>
                            </div>
                        </div>
                        <ul>
                            <ScheduleCard></ScheduleCard>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Woensdag</div>
                                <div class="schedule-top-day-number">21</div>
                            </div>
                        </div>
                        <ul>

                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Donderdag</div>
                                <div class="schedule-top-day-number">22</div>
                            </div>
                        </div>
                        <ul>
                            <ScheduleCard></ScheduleCard>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Vrijdag</div>
                                <div class="schedule-top-day-number">23</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Zaterdag</div>
                                <div class="schedule-top-day-number">24</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                    <li class="schedule-group">
                        <div class="schedule-top-info">
                            <div class="width-100 relative text-center">
                                <div class="schedule-top-day-name">Zondag</div>
                                <div class="schedule-top-day-number">25</div>
                            </div>
                        </div>
                        <ul>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import Input from "../../components/Input/Input";
    import ScheduleCard from "../../components/ScheduleCard/ScheduleCard";

    export default {
        name: 'schedule',
        components: {
            Input,
            ScheduleCard
        },
        props: [],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {
            var schedule = document.getElementsByClassName('schedule');
            var highestScheduleSize = 0;
            for (var i = 0; schedule[i]; i++) {
                var scheduleCard = schedule[i].getElementsByClassName('schedule-card');
                var totalScheduleCardHeight = 4;
                for (var u = 0; scheduleCard[u]; u++) {
                    scheduleCard[u].style['top'] = totalScheduleCardHeight + 'px';
                    totalScheduleCardHeight += scheduleCard[u].offsetHeight + 8;
                }
                var scheduleEvents = schedule[i].getElementsByClassName('schedule-events');
                if (totalScheduleCardHeight != 0) {
                    scheduleEvents[0].style['height'] = totalScheduleCardHeight + 60 +'px';
                } else {
                    scheduleEvents[0].style['height'] = 180 +'px';
                }

            }
        },
        methods: {

        }
    }

</script>
<style src="./Schedule.scss" scoped lang="scss"></style>

